import { moduleHeaderList } from '../utils/header-list';
import { NavigationEnd, Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable( {
  providedIn: 'root'
} )
export class HeaderService {
  
  private router = inject(Router);

  router$: Subscription;
  moduleHeaderItem: BehaviorSubject<any> = new BehaviorSubject( [] );
  sideBarState: BehaviorSubject<any> = new BehaviorSubject( false );

  constructor() {
    this.router$ = this.router.events.subscribe( event => {

      if( event instanceof NavigationEnd ) {
        const headerItem = moduleHeaderList.filter( item => {
          return item.path === '/pages/' + event.urlAfterRedirects.split( '/' )[2];
        } );
        this.moduleHeaderItem.next( headerItem[0] );

      }
    } );
  }
}
